import React, { forwardRef } from 'react';

import { Box } from 'src/components/Box';
import { BUTTON_COLOR, BUTTON_VARIANT } from '../Button/types';

import PaginationRoot from './PaginationRoot';
import { PaginationRootProps } from './types';

const Pagination = forwardRef(
  (
    {
      item = false,
      variant = BUTTON_VARIANT.GRADIENT,
      color = BUTTON_COLOR.INFO,
      size = 'medium',
      active = false,
      children,
      ...rest
    }: PaginationRootProps,
    ref,
  ) => {
    return (
      <>
        {item ? (
          <PaginationRoot
            {...rest}
            ref={ref}
            variant={active ? variant : BUTTON_VARIANT.OUTLINED}
            color={active ? color : BUTTON_COLOR.SECONDARY}
            iconOnly
            circular
            ownerState={{ variant, active, paginationSize: size }}>
            {children}
          </PaginationRoot>
        ) : (
          <Box
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
            sx={{ listStyle: 'none' }}>
            {children}
          </Box>
        )}
      </>
    );
  },
);

export { Pagination };
